import { Box, Button } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useEffect, useMemo, useState } from "react"
import { generate } from "library/guid/index.mjs"
import { AcceptAll, AcceptedChanged, IsAccepted } from "event-definitions"
import { LocalAddition } from "routes/schedule/compare/localAddition"
import { RemoteAddition } from "routes/schedule/compare/remoteAddition"
import { Conflict } from "routes/schedule/compare/conflict"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { OnlyWithoutComparisonReadOnly } from "./only-without-comparison-read-only"

export function getInfoFor(rendered = []) {
    let output = null

    rendered.forEach((component) => {
        if (component.props.isLocal) {
            output = output?.type.name !== "Conflict" ? <LocalAddition /> : output
        }
        if (component.props.isRemote) {
            output = output?.type.name !== "Conflict" ? <RemoteAddition /> : output
        }
        if (component.props.isConflict) {
            output = <Conflict />
        }
    })

    return output
}

export function AcceptButton({ id, rendered }) {
    const { canSave, popupEditor } = useBoundContext()
    const [buttonId] = useState(() => id ?? generate())
    const uniqueId = useMemo(() => generate(), [])
    const [accepted, setAccepted] = useState(IsAccepted.call({ isAccepted: false, id: buttonId }))
    AcceptAll.useEvent((accept) => {
        setAccepted(accept)
    })
    useEffect(() => {
        AcceptedChanged.raise({ id: buttonId, accepted, uniqueId })
    }, [uniqueId, accepted, buttonId])
    useEffect(
        () => () => {
            AcceptedChanged.raise({ id: buttonId, accepted: undefined, uniqueId })
        },
        [buttonId, uniqueId]
    )
    const info = getInfoFor(rendered)
    return (
        canSave &&
        !popupEditor && (
            <OnlyWithoutComparisonReadOnly>
                <ListItemBox sx={{ mt: 0.5, mb: 0.5, ml: 4, mr: 4 }} width={1}>
                    <Box mr={2}>
                        <Button
                            className="accept"
                            size="small"
                            color="primary"
                            variant={!accepted ? "outlined" : undefined}
                            startIcon={accepted && <Iconify icon="mdi:check" />}
                            onClick={accept}
                            sx={{ mr: 2 }}
                        >
                            {accepted ? "Approved" : "Approve"}
                        </Button>
                    </Box>
                    {info}
                </ListItemBox>
            </OnlyWithoutComparisonReadOnly>
        )
    )

    function accept() {
        setAccepted(!accepted)
    }
}
